module.exports = __webpack_public_path__ + "img/gpr_logo.5f8c53ce.png";